export const logIfDebug = (
	message: any,
	params: any[] | {} | undefined = undefined
) => {
	if (!isDev()) {
		return;
	}

	console.log(message, params ?? null);
};

export const logErrorIfDebug = (
	message: any,
	params: any[] | {} | undefined = undefined
) => {
	if (!isDev()) {
		return;
	}

	console.error(message, params ?? null);
};

export const isDev = () => {
	return process.env.NODE_ENV === "development";
};

export const startPerformance = () => {
	return (isDev() && performance.now()) ?? 0;
};

export const endPerformance = () => {
	return startPerformance();
};

export const logPerformance = (
	startTime: number,
	endTime: number,
	callType: string
) => {
	logIfDebug(`Call to ${callType} took ${endTime - startTime} milliseconds`);
};
